<template>
  <div>
    <b-container v-if="isLoading" class="text-center d-flex justify-content-center">
      <b-form>
        <br><br><br>
        <h5>{{ translate("loading") }}</h5>
        <br>
        <b-spinner style="color: rgb(109,122,82) !important"
          variant="warning"
        ></b-spinner>
      </b-form>
    </b-container>
    <div v-else>
      <b-container fluid v-if="this.inSession">
        <b-row>
          <b-col md="2" style="padding:0">
            <MenuDesktop/>
          </b-col>
          <b-col md="10" style="padding:0" align="center">
            <br>
            <p v-if="bottle.name" class="w-pagetitle" style="margin-left:20px;margin-right:20px; text-align:right;">
              <span v-on:click="gotoWishlist()" class="w-cursor-click" ><u>{{ translate("wishlist") }}</u></span> 
              > {{ translate("show bottle") }}
            </p>           
            <div style="width: 80%; margin: 2vh 10vw 0 10vw !important">
              <b-row>
                <br>
                <b-tabs class="w-tabs" v-model="tabIndex" fill>
                  <div class="w-tabbox">
                    <b-tab class="w-tab" :title="translate('from database')">
                      <div style="width: 80%; margin: 0 0 0 0 !important">
                        <b-row v-if="wine_id !=0">
                          <b-col md="4">
                            <b-row v-if="wine.image_files.length > 0" class="justify-content-center">
                              <b-carousel
                              id="carousel-fade"
                              :interval="4000"
                              controls
                              indicators
                              background="#ffffff"
                              img-width="100"
                              img-height="300"
                              style="width:max-content;height:auto"
                              >
                                <b-carousel-slide v-for="image_file in wine.image_files" v-bind:key="image_file.dataURL">
                                  <template v-slot:img>
                                    <b-img   
                                      v-bind:src="image_file.dataURL"
                                      style="height:50vw;position:relative;right:0px"
                                    />
                                  </template>
                                </b-carousel-slide>
                              </b-carousel>
                            </b-row>
                            <b-row v-else>
                              <b-img center
                                style="height:50vw;position:relative;right:0px"
                                :src="require('@/assets/img/bottle.png')"
                              ></b-img>
                            </b-row> 
                          </b-col>
                          <b-col md="8">
                            <div>
                              <div>
                                <h1 class="preview-title">{{this.wine.name}} {{ this.bottle.vintage }}</h1> 
                                <h5 class="preview-subtitle">{{this.wine.type}}</h5>
                                <hr>
                                <p class="preview-text"><span v-if="this.wine.region !=''">{{this.wine.region}},</span> {{this.wine.country}}</p>
                                <p class="preview-text"><span v-if="this.wine.appellation !=''">{{this.wine.appellation}},</span> {{this.wine.classification}}</p>
                              </div>
                              <div v-for="(value, key) in this.wine" v-bind:key="key">
                                <div v-if="key==='tasting_notes' && value.length>0">
                                  <hr>
                                  <p  class="w-text" style="font-style:italic">{{value}}</p>
                                </div>  
                                <div v-if="key==='grapes' || key==='vines' || key==='vinification' || key === 'yields'">
                                  <p  class="w-text" v-if="value.length>0"><b>{{ key }}</b> : {{value}}</p>
                                </div>
                              </div>
                              <hr>
                            </div>
                          </b-col>
                        </b-row>
                        <b-row v-else>
                          <p class="t-title">ERROR NO VALID wine_id</p>
                        </b-row>
                        <b-row>
                        </b-row>
                      </div>
                    </b-tab>
                  </div>
                </b-tabs>
              </b-row>
              <br>
              <b-row>
                <b-col style="text-align:left;padding-left:15px">
                  <b-button v-on:click="onBack()" class="w-button-pink">{{ translate("back") }}</b-button>
                </b-col>
              </b-row>
              <br>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <NoAccess v-else></NoAccess>
    </div>
  </div>
</template>

<script>
  import {wordlist,translate_word} from '../assets/js/translate.js';

  import NoAccess from './NoAccess.vue';
  import MenuDesktop from './MenuDesktop.vue';

  export default {
    name: 'BottleShow',
    components:{
      NoAccess,
      MenuDesktop,
    },
    computed : {
      inSession() {
        return this.$store.state.inSession
      },
      currentLanguage() {
        return this.$store.state.language
      },
      currentPage() {
        return this.$store.state.current_page
      },
      previousPage() {
        return this.$store.state.previous_page
      },

      Bottle() {
        return this.$store.state.bottle
      },
      BottleID() {
        return this.$store.state.bottle_id
      },
      Wine() {
        return this.$store.state.wine
      },
      WineID() {
        return this.$store.state.wine_id
      },
    },
    data() {
      return {
        debug: false,

        isLoading: true,
      }
    },
    async mounted() {
      let local_debug = false
      if (local_debug || this.debug) console.log("")
      if (local_debug || this.debug) console.log("=====> BottleShow.mounted: START")
      
      // Read the STORe
      this.bottle = this.Bottle;
      this.bottle_id = this.BottleID;
      if (local_debug || this.debug) console.log("=====> BottleShow.mounted: store read bottle =", JSON.stringify(this.bottle,null,2), "bottle_id =", this.bottle_id);

      if (this.bottle.wine_id != 0) {
        this.wine_id = this.bottle.wine_id;
        this.wine = this.Wine;
        this.tabIndex = 0
        this.hideManual = true
        if (local_debug || this.debug) console.log("=====> BottleShow.mounted: store read wine =", 
          JSON.stringify(this.wine, (key, value) => {
            if (key === "image_files") return undefined; // skip this field
            return value;
          }, 2),
          "wine_id =", this.wine_id);
      } 

      if (local_debug || this.debug) console.log("=====> BottleShow.mounted: STOP")
      this.isLoading = false;
    },
    methods: {
      onBack() {
        this.$router.push({path:'/WishList'});
      },
      gotoWishlist() {
        this.$store.commit('setPage','Wishlist')
        this.$router.push({path:'/Wishlist'});
      },
      translate(string) {
        return translate_word(string, this.currentLanguage);
      },
    }
  }
</script>
